﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BurnableABI = void 0;
class BurnableABI {
    static GetABI() {
        return [
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "amount",
                        "type": "uint256"
                    }
                ],
                "name": "burn",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            }
        ];
    }
}
exports.BurnableABI = BurnableABI;
//# sourceMappingURL=BurnableABI.js.map